import { getFullAddress } from "@/utils/helper";

export const getTypeBroker  = (type: string) => {
  return type === 'individual' ? 'Cá nhân' : 'Công ty'
}

export const formatTableDataBrokerApprove = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    code: item?.user?.code || '',
    avatar: item?.user?.avatar?.url?.thumbnail || '',
    phone: item?.user?.phone_number || '',
    email: item?.user?.email || '',
    full_name: item?.user?.full_name || '',
    regions: parseRegions(item?.regions || []),
    birthday: item?.user?.birthday || '-',
    business_type: getTypeBroker(item.business_type),
  }));
}

export const getStatusBroker = (processing_status: string) => {
  // processing_status
  // pending: 'pending',
  // approved: 'approved',
  // rejected: 'rejected',
  switch (processing_status) {
    case 'pending':
      return 'Đang chờ duyệt';
    case 'approved':
      return 'Đã duyệt';
    case 'rejected':
      return 'Đã từ chối';
    default:
      return '';
  }
}

export const getStatusBrokerObject = (processing_status: string) => {
  switch (processing_status) {
    case 'pending':
      return [{ label: 'Đang chờ duyệt', type: 'warn' }];
    case 'approved':
      return [{ label: 'Đã duyệt', type: 'success' }];
    case 'rejected':
      return [{ label: 'Đã từ chối', type: 'danger' }];
    default:
      break;
  }
}

export const BROKER_LEVEL: any = {
  regional_director: 'Giám đốc vùng',
  associate: 'Môi giới',
  manager: 'Quản lý',
};

export const BUSINESS_TYPE_ARRAY: any = [
  { name: 'Cá nhân', code: 'individual' },
  { name: 'Công ty', code: 'company' }
]

export const BROKER_LEVEL_ARRAY: any = [
  { name: 'Giám đốc vùng', code: 'regional_director' },
  { name: 'Môi giới', code: 'associate' },
  { name: 'Quản lý', code: 'manager' }
]

export const getBrokerLevel = (broker_level: string) => {
  switch (broker_level) {
    case 'regional_director':
      return 'Giám đốc vùng';
    case 'associate':
      return 'Môi giới';
    case 'manager':
      return 'Quản lý';
    default:
      return '';
  }
}

const getTypeCertificate = (mime_type: string) => {
  if (mime_type.includes('pdf')) {
    return 'pdf';
  } else if (mime_type.includes('png')) {
    return 'png';
  }else if (mime_type.includes('doc')) {
    return 'doc';
  }
  return '';
}

export const getCertificateBroker = (certificates: any[]) => {
  // [
  //   {type: 'doc', fileName: 'GIT WORKFLOW & PRINCIPLE ENJOYWORK.docx', fileUrl: 'https://s3.nicecollab.org/upload/GIT%20WORKFLOW%20&%20PRINCIPLE%20ENJOYWORK.docx', size:1024000},
  //   {type: 'pdf', fileName: 'Report on Research and Customization Results of OpenWebUI.pdf', fileUrl: 'https://s3.nicecollab.org/upload/Report%20on%20Research%20and%20Customization%20Results%20of%20OpenWebUI.pdf', size:1024000},
  //   {type: 'png', fileName: 'file-sample_1MB.pdf', fileUrl: 'https://file-examples.com/wp-content/storage/2017/02/file-sample_1MB.pdf', size:1024000},
  // ]
  if (!certificates || !Array.isArray(certificates)) {
    return [];
  }

  return certificates.map((item) => ({
    ...item,
    fileName: item?.filename || '',
    fileUrl: item?.url.original || '',
    type: getTypeCertificate(item?.mime_type) || '',
    size: item?.file_size || '',
  }));
}

export const formatTableDataBrokerList = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    code: item?.user?.code || '',
    avatar: item?.user?.avatar?.url?.thumbnail || '',
    processing_status: getStatusBrokerObject(item?.processing_status),
    phone: item?.user?.phone_number || '',
    email: item?.user?.email || '',
    full_name: item?.user?.full_name || '',
    regions: parseRegions(item?.regions),
    birthday: item?.user?.birthday || '-',
    business_type_text: getTypeBroker(item.business_type),
    broker_level_text: getBrokerLevel(item.broker_level),
    broker_level: item.broker_level,
    business_type: item.business_type,
    manager: '-',
  }));
}

function parseRegions(data: any[]) {
  // console.log(131, data)
  const result = data.map(item => {
    return item.name + ', ' + item.level1.name;
  })
  // console.log(135, result)
  return result;
}

export const formatDataBrokerDetail = (item: any) => {
  return {
    ...item,
    code: item?.user?.code || '',
    avatar: item?.user?.avatar?.url?.thumbnail || '',
    processing_status_text: getStatusBrokerObject(item?.processing_status),
    phone_number: item?.user?.phone_number || '',
    email: item?.user?.email || '',
    full_name: item?.user?.full_name || '',
    certificates: getCertificateBroker(item.certificates),
  };
}

export const formatTableDataSubMember = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    code: item?.user?.code || '',
    profile_pic: item?.user?.avatar?.url?.thumbnail || '',
    fullname: item?.user?.full_name || '',
    phone: item?.user?.phone_number || '',
    email: item?.user?.email || '',
    type: getTypeBroker(item.business_type),
    rate: item?.point || '',
    level: getBrokerLevel(item.broker_level),
    submem: item?.submem || '-',
    regdate: item?.created_at || '-',
  }));
}
